import { RobotFilled } from "@ant-design/icons-vue";
import { getComponent } from "../utils";
import { h } from "vue";
import { prefix } from "../prefix";
import Layout from '@/layouts/main-layout.vue'
import type { RouteRecordRaw } from "vue-router";

export const assistant_routes: RouteRecordRaw[] = [
  {
    path: '/assistant/list',
    name: 'assistant-list',
    component: () => getComponent(`pages/assistant/assistant-list.vue`),
    meta: {
      title: () => 'Assistants',
      layout: Layout,
      is_public: false,
      menu: {
        key: 'Assistants',
        label: 'Assistants',
        icon: () => h(RobotFilled),
        path: `${prefix}/assistant/list`,
      },
    },
  },
  {
    path: '/assistant/new',
    name: 'assistant-new',
    component: () => getComponent(`pages/assistant/assistant-new.vue`),
    meta: {
      title: () => `New Assistant`,
      layout: Layout,
      is_public: false,
    },
  },
  {
    path: '/assistant/:id(\\d+)+/edit',
    name: 'assistant-edit',
    component: () => getComponent(`pages/assistant/assistant-edit.vue`),
    meta: {
      title: () => `Edit Assistant`,
      layout: Layout,
      is_public: false,
    },
  },
  {
    path: '/assistant/:id(\\d+)+',
    name: 'assistant-details',
    component: () => getComponent(`pages/assistant/assistant-details.vue`),
    meta: {
      title: ({ id }: { id: string }) => `Assistant #${id}`,
      layout: Layout,
      is_public: false,
    },
  },
]
